import "./styles/editBox.css";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";


import Select from "../form_components/Select/Select";
import WhiteButton from "../form_components/Buttons/WhiteButton/WhiteButton";
import { Tooltip } from "antd";

function OfferEditBox({
  t,

  type,

  searchText,
  setSearchText,

  offersPageLink,

  tableFilter,
  setTableFilter,

  statusFilter,
  setStatusFilter,

  useFetchRender,
  setUseFetchRender,

  selectValueId,
  setSelectValueId,

  selectValue,
  setSelectValue,

  handleOpenConfirmModal,
  handleOpenDeleteModal,
  handleOpenRevisedModal,
  handleOpenRevisedNoteModal,
  handleOpenResultRevisedNoteModal,
}) {
  const [isSearchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef(null);

  /* SEARCH-START */
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setSearchOpen(false);
    }
  };
  /* DROPDOWN-END */

  /* process => Yapılacak işlem (düzenle,sil,..) */
  function handleClick(process) {
    switch (process) {
      case "render":
        console.log("Tablo yenilendi!", useFetchRender);

        setUseFetchRender(!useFetchRender);

        setSearchOpen(false);

        setSelectValueId(null);
        setSelectValue(null);

        break;

      case "search":
        console.log("Bul a tıklandı!");
        // alert("Bul a tıklandı!");

        setSearchOpen(true);

        break;

      case "revised":
        console.log("Revize ye tıklandı!");

        handleOpenRevisedModal();

        break;

      case "delete":
        console.log("delete a tıklandı!");

        handleOpenDeleteModal();

        setSearchOpen(false);

        break;

      case "confirm":
        console.log("offer a tıklandı!");

        handleOpenConfirmModal();

        setSearchOpen(false);

        break;

      case "revised-note":
        console.log("revised-note a tıklandı!");

        handleOpenRevisedNoteModal();

        setSearchOpen(false);

        break;

      case "result-revised-note":
        console.log("result-revised-note a tıklandı!");

        handleOpenResultRevisedNoteModal();

        setSearchOpen(false);

        break;

      default:
        break;
    }
  }

  const selectOptions = [
    { key: 1, text: t("select_options_increased_price") },
    { key: 2, text: t("select_options_decreasing_price") },
    { key: 3, text: t("select_options_new_to_old") },
    { key: 4, text: t("select_options_old_to_new") },
  ];


  return (
    <div className="edit-container">
      <div className="edit-box">
        <div className="edit-container-title">
          <h4 className="title">
            {" "}
            <i className="fa-solid fa-star" /> {t("offers_title")}
          </h4>
        </div>

        <div className="edit-container-button-group">
          <WhiteButton
            icon={<i className="fa-solid fa-arrow-rotate-right" />}
            tooltip={t("button_edit_render")}
            onClick={() => handleClick("render")}
          />

          {/* <WhiteButton
            icon={<i className="fa-solid fa-magnifying-glass" />}
            text={
              isSearchOpen ? (
                <div ref={searchRef} className="search-container">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              ) : null
            }
            onClick={() => handleClick("search")}
          /> */}
          <WhiteButton
            icon={
              isSearchOpen ? (
                <div ref={searchRef} className="search-container">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )
            }
            tooltip={t("button_edit_search")}
            onClick={() => handleClick("search")}
          />

          <Select
            name="filter"
            options={selectOptions}
            select={tableFilter}
            setSelect={setTableFilter}
            className="select-filter-sort"
          />

          {offersPageLink === "waiting-offer" && (
            <>
              <Tooltip placement="top" title={t("select_options_filtered")}>
                <select onChange={(e) => setStatusFilter(e.target.value)}>
                  <option value={"all"}>{t("select_options_all")}</option>
                  <option value={1}>{t("select_options_wait")}</option>
                  <option value={3}>{t("select_options_revised")}</option>
                </select>
              </Tooltip>

              <WhiteButton
                icon={<i className="fa-solid fa-trash-can"></i>}
                tooltip={t("button_edit_delete")}
                onClick={() => handleClick("delete")}
                disabled={selectValueId || selectValue ? false : true}
              />
            </>
          )}

          <Link
            to={
              selectValueId || selectValue
                ? `offer-detail/${selectValueId}`
                : false
            }
          >
            <WhiteButton
              icon={<i className="fa-solid fa-info" />}
              tooltip={t("button_edit_detail")}
              disabled={selectValueId || selectValue ? false : true}
            />
          </Link>

          {selectValue?.result === "3" && (
            <Link
              to={`/opportunities/tender-detail-offer/${selectValue?.tenderId}`}
            >
              <WhiteButton
                icon={<i className="fa-solid fa-cart-plus"></i>}
                tooltip={t("button_request_offer")}
              />
            </Link>
          )}

          {selectValue?.result === "3" && (
            <WhiteButton
              icon={<i className="fa-solid fa-note-sticky"></i>}
              tooltip={t("button_edit_revised_note")}
              onClick={() => handleClick("result-revised-note")}
              disabled={selectValueId || selectValue ? false : true}
            />
          )}

          {selectValue?.status === "3" ? (
            <>
              <WhiteButton
                icon={<i className="fa-solid fa-note-sticky"></i>}
                tooltip={t("button_edit_revised_note")}
                onClick={() => handleClick("revised-note")}
                disabled={selectValueId || selectValue ? false : true}
              />
              <Link to={`offer-edit/${selectValueId}`}>
                <WhiteButton
                  icon={<i className="fa-solid fa-pen-to-square"></i>}
                  tooltip={t("button_edit_update")}
                  onClick={() => handleClick("update")}
                  disabled={selectValueId || selectValue ? false : true}
                />
              </Link>
            </>
          ) : selectValue?.status === "1" ? (
            <>
              <WhiteButton
                icon={<i className="fa-solid fa-rotate"></i>}
                tooltip={t("button_request_revision")}
                onClick={() => handleClick("revised")}
                disabled={selectValueId || selectValue ? false : true}
              />

              <WhiteButton
                icon={<i className="fa-solid fa-check"></i>}
                tooltip={t("button_edit_confirm")}
                onClick={() => handleClick("confirm")}
                disabled={selectValueId || selectValue ? false : true}
              />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default withNamespaces()(OfferEditBox);
